module.exports = __webpack_public_path__ + "static/media/autoDoor5.1ab64ff0.png";